import { render, staticRenderFns } from "./LavaderoKanban.vue?vue&type=template&id=4a62b25d&scoped=true"
import script from "./LavaderoKanban.vue?vue&type=script&lang=js"
export * from "./LavaderoKanban.vue?vue&type=script&lang=js"
import style0 from "./LavaderoKanban.vue?vue&type=style&index=0&id=4a62b25d&prod&lang=css"
import style1 from "./LavaderoKanban.vue?vue&type=style&index=1&id=4a62b25d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a62b25d",
  null
  
)

export default component.exports